import { render, staticRenderFns } from "./OrderServiceComments.vue?vue&type=template&id=12616e80&scoped=true&"
import script from "./OrderServiceComments.vue?vue&type=script&lang=js&"
export * from "./OrderServiceComments.vue?vue&type=script&lang=js&"
import style0 from "./OrderServiceComments.vue?vue&type=style&index=0&id=12616e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12616e80",
  null
  
)

export default component.exports